import CustomFieldProto from '../../proto/custom-field-proto';

import ListComponent from './components/list/formula-list';
import ListGroupHeaderComponent from "./components/group/formula-group-list-header";
import ViewComponent from './components/view/formula-view';
import EditComponent from './components/edit/formula-edit';
import FormComponent from "./components/form/formula-form-add";
import FormNewComponent from './components/form/formula-form-new';
import FieldTextViewInImport from "../../import/view-in-preview/long-text-view-in-preview";
import Formula from "src/core/gd/utils/formula";
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateNumberComponent from "../number/components/aggregate-number";
import AggregateCurrencyComponent from "../currency/components/aggregate-currency";
import AggregatePercentage from "../percentage/components/aggregate-percentage"

export default class FormulaCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    isFormulaValid() {
        return Formula.isFormulaValid(this.customField.params.formula).isValid;
    }

    static getValue(item, formula) {
        return Formula.process(formula, item).result;
    }

    getFormulaWithValues(item) {
        return Formula.process(this.customField.params.formula, item).formulaWithValues;
    }

    getValue(item) {
        return FormulaCustomField.getValue(item, this.customField.params.formula);
    }

    getCsvValue(item) {
        return FormulaCustomField.getValue(item, this.customField.params.formula);
    }

    getCurrencyMark() {
        const formatType = this.customField.params ? this.customField.params.formatType : null;
        let currencyMark = '';

        if (formatType === 'currency') {
            const currencyId = this.customField.params ? this.customField.params.symbol : null;

            for (let availableCurrId in gd.const.currency) {
                if (availableCurrId === currencyId)  {
                    currencyMark = gd.const.currency[availableCurrId].symbol;
                    break;
                }
            }
        }

        return currencyMark;
    }

    getPostfix() {
        const formatType = this.customField.params ? this.customField.params.formatType : null
        return formatType === 'percentage' ? ' %' : ''
    }

    getDecimalPlaces() {
        return this.customField.params ? this.customField.params.decimalPlaces : 0;
    }

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!FormulaCustomField.getValue(i.item, this.customField.params.formula) ? 1 : 2,
                i => FormulaCustomField.getValue(i.item, this.customField.params.formula)
            ],
            directions: ['asc', sort]
        }
    }

    get ListComponent()             {return ListComponent.bind(null, this.customField.id);}
    get ListGroupHeaderComponent()  {return ListGroupHeaderComponent.bind(null, this.customField.id);}
    get ViewComponent()             {return ViewComponent.bind(null, this.customField.id);}
    get EditComponent()             {return EditComponent.bind(null, this.customField.id);}
    get FormAddComponent()          {return FormComponent;}
    get FormNewComponent()          {return FormNewComponent.bind(null, this.customField.id);}
    get AggregateComponent()        {
        const formatType = this.customField.params ? this.customField.params.formatType : null;
        switch (formatType) {
            case 'currency'     : return AggregateCurrencyComponent.bind(null, this.getAggregateOptions(), this.customField.params);
            case 'percentage'   : return AggregatePercentage.bind(null, this.getAggregateOptions(), this.customField.params);
            case 'number'       :
            default             : return AggregateNumberComponent.bind(null, this.getAggregateOptions(), this.customField.params);
        }
    }
    // IMPORT
    normalizeCSVValue(value) {
        return value ? value.trim() : null;
    }

    getComponentViewInImport() {
        return FieldTextViewInImport;
    }

}